import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Tier } from '../models';

@Component({
    selector: 'app-tier',
    templateUrl: './tier.component.html',
    styleUrls: ['./tier.component.scss'],
})
export class TierComponent implements OnInit {
    @Input() tier: Tier;
    @Input() userTier: Tier;
    @Input() isActive = false;
    @Input() isSelected = false;
    @Input() showSelect = true;

    @Output() select = new EventEmitter<Tier>();

    dollars = 0;
    cents = '00';

    ngOnInit() {
        this.dollars = Math.floor(this.tier.price / 100);
        const cents = this.tier.price / 100 - this.dollars;
        this.cents = '.' + this.pad(Math.floor(cents * 100), 2);
    }

    pad(n, width) {
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
    }

    onSelect() {
        this.select.emit(this.tier);
    }
}
